import { ApplicationRef, Component } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    constructor(
        private _updates: SwUpdate,
        private _appRef: ApplicationRef
    ) {
        this.updateClient();
        // this.checkUpdate(); // try disable see how, if needed then re-enable it
    }

    updateClient() {

        if (!this._updates.isEnabled) {
            return;
        }

        this._updates.available.pipe(untilDestroyed(this)).subscribe(() => {
            if (confirm("Updates are available, please reload to get updates")) {
                this._updates.activateUpdate().then(() => location.reload());
            }
        });
    }

    // will hit infinite loop issue, temporary disable
    // checkUpdate() {
    //     this._appRef.isStable.pipe(untilDestroyed(this)).subscribe(isStable => {
    //         if (isStable) {
    //             const timeInterval = interval(10 * 60 * 60 * 1000); // 10 hours

    //             timeInterval.pipe(untilDestroyed(this)).subscribe(() => {
    //                 this._updates.checkForUpdate().then(() => {
    //                     this.updateClient();
    //                 });
    //             });
    //         }
    //     });
    // }
}
